import React from 'react';
import './style.css'
import HeaderComponent from './components/header/index';
import SidebarComponent from './components/sidebar/index';
import HomeComponent from './scenes/home/index';
import CreateAccountComponent from './scenes/create-account';
import MovementsComponent from './scenes/movements/index';
import Registers from './scenes/registers/index';
import ConfigComponent from './scenes/config/index';
import {Route, Redirect, Switch} from 'react-router-dom';
import DoctorsComponent from './scenes/doctors/index';
import DiagnosticsComponent from './scenes/diagnostics';
import AppointmentDetails from './scenes/appointment-details/index';
import AddJson from './scenes/add-json/index';

export default class MainPage extends React.Component {
    render() {
        return (
            <div className="MainPage">
                <SidebarComponent user={this.props.user} />
                <div className="page-content">
                    <HeaderComponent logout={this.props.logout} user={this.props.user} />
                    <Switch>
                        <Route path="/home"
                            render={(props) =>
                                <HomeComponent {...props} user={this.props.user} />}/>
                        <Route path="/create-account"
                            render={(props) =>
                                <CreateAccountComponent {...props} user={this.props.user} />}/>
                        <Route path="/doctors" component={DoctorsComponent} />
                        <Route path='/movements' component={MovementsComponent}/>
                        <Route path='/registers'
                            render={(props) =>
                                <Registers {...props} user={this.props.user} />}/>
                        />
                        <Route path='/config'
                            render={(props) =>
                                <ConfigComponent {...props} updateUser={this.props.updateUser} user={this.props.user} />}/>
                        />
                        <Route path='/diagnostics' component={DiagnosticsComponent}/>
                        <Route path="/appointment-details/:appointment/:timestamp?/:chair?"
                            render={(props) =>
                                <AppointmentDetails {...props} user={this.props.user} />}/>
                        />
                        <Route path="/add-json"
                            render={(props) =>
                                <AddJson {...props} user={this.props.user} />}/>
                        />
                        <Route render={() => {
                            if(this.props.user.role == "developer") {
                                return <Redirect to="/add-json" />
                            }
                            return <Redirect to="/home" />
                        }}/>
                    </Switch>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/index.js